module.exports = __webpack_public_path__ + "static/media/video steel.5786779.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/customization/SteelOApp/pages/Login/Assets/Video/video steel.mp4
// module id = sChM
// module chunks = 0